import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const SelectionService = lazy(() => import('./index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/selection-service/zhanggong',
    element: <SelectionService title='ZhangGong'/>,
  },
  {
    path: '/selection-service/ximenziTIA',
    element: <SelectionService title='XiMenZiTIA'/>,
  },
  {
    path: '/selection-service/ximenzi',
    element: <SelectionService title='XiMenZi'/>,
  },
];
